import type { ElementType } from 'react';

import { Link } from '@chakra-ui/react';

import type { NavItemProps } from './types/nav-item.props';

const NavItem = <TElementType extends ElementType = 'div'>({
  as = 'div' as TElementType,
  isActive,
  label,
  ...props
}: NavItemProps<TElementType>) => {
  return (
    <Link
      {...props}
      _hover={{ borderColor: 'hsp.500', cursor: 'pointer' }}
      as={as}
      bg={isActive ? 'hsp.500' : 'transparent'}
      borderWidth={1}
      color={isActive ? 'white' : 'hsp.500'}
      fontWeight="bold"
      p={2}
      rounded="lg"
      textDecoration="none"
      whiteSpace="nowrap">
      {label}
    </Link>
  );
};

export default NavItem;
